<template>
    <el-row :gutter="30">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :loading="loadingBtn">
            <el-form label-width="120px">
                <el-form-item label="Number">
                    <el-select
                        filterable
                        v-model="selectedPhoneNumber" placeholder="Select phone number" v-loading="loadingNumber">
                        <el-option
                            v-for="numb in number" :key="numb"
                            :label="numb"
                            :value="numb">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="File">
                    <el-upload
                        class="upload-demo"
                        drag
                        ref="upload"
                        v-loading="loadingBtn"
                        :http-request="uploadFile"
                        :action="uploadUrl"
                        :headers="uploadHeaders"
                        :fileList="uploadedFileList"
                        :auto-upload="false"
                        :data="{ param: 'phone', type: 'csv', sender: selectedPhoneNumber }"
                        name="csv_file">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                            <div class="el-upload__tip" slot="tip">csv files with a size less than 500kb</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="Recipient Email">
                    <el-input v-model="tempEmail" placeholder="Separate email with space"></el-input>
                    <!-- <small v-if="showErrorEmail">Invalid email</small> -->
                    <el-tag style="margin-right: 4px" :closable="true" @close="email.splice(index)" v-for="(val, index) in email" :key="index">{{ val }}</el-tag>&nbsp;
                </el-form-item>
                <el-form-item>
                    <el-button :loading="loadingBtn" type="success" @click="$refs.upload.submit()">Upload</el-button>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
</template>
<script>
import config from '@/config'
import axios from 'axios'
export default {
    name: 'InquiryNumber',
    props:{
        number: {
            type: Array
        }
    },
    data() {
        return {
            loadingBtn: false,
            loadingNumber: false,
            showErrorEmail: false,
            uploadUrl: config.baseApi + 'whatsapp/inquiryNumber',
            uploadHeaders: {
                'api-key': this.$store.getters.accessToken,
            },
            selectedPhoneNumber: "",
            uploadedFileList: [],
            tempEmail: "",
            email: []
        }
    },
    methods: {
        uploadFile(object){
            let maxSizeAllowed = 500 * 1000 // bytes * 1000
            if(object.file.size > maxSizeAllowed){
                this.$swal(this.$t('warning'), this.$t(`upload_max_size`), "warning")
            } else if(['text/csv', 'application/vnd.ms-excel'].indexOf(object.file.type) == -1) {
                this.$swal(this.$t('warning'), this.$t(`file_not_allowed`) + ' csv', "warning")
            } else{
                this.checkContact('csv', object.file)
            }
        },
        async loadWA() {
            this.loadingNumber = true
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_number'
			}).then(result => {
                this.number = result.data.data
			}).catch(error => {
				this.showAlertError = true
			})
            this.loadingNumber = false
    	},
        async checkContact(type = '', file = null){
            if(this.email.length == 0){
                this.$message.error("You must fill all fieled")
                return;
            }
            this.loadingBtn = true
            this.showResult = false
            let formData = new FormData();
            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            if(type == 'csv'){
                // var input = document.getElementById('inputCsvFile')
                formData.append('csv_file',file)
                apiOptions.responseType = "arraybuffer"
            } else{
                formData.append('phone', this.contactForm.phoneNumber)
            }
            formData.append('type', type)
            formData.append('sender', this.selectedPhoneNumber)
            formData.append('email', this.email)
            
            await axios.post(config.baseApi + 'whatsapp/inquiryNumber/' + this.$route.params.consumen, formData, apiOptions).then(resp => {
                if(type == 'single'){
                    this.showResult = true
                    this.checkResult.contact = resp.data.data.contact
                    this.checkResult.status = resp.data.data.status.toUpperCase()
                } else{
                    this.uploadedFileList.push({
                        "status":"success",
                        "name":file.name,
                        "size": file.size,
                        "percentage":100,
                        "uid": file.uid
                    })
                    this.$swal(this.$t('success'), "We will sent you an email after all done. Thank you.", "success")
                }
            }).catch(err => {
                 if(type == 'single'){
                    this.showResult = true
                    this.checkResult.contact = this.contactForm.phoneNumber
                    this.checkResult.status = "FAILED_CHECK"
                } else{
                    this.$swal(this.$t('error'), this.$t(`error_text`), "error")
                }
            })
            this.loadingBtn = false
        }
    },
    mounted(){

    },
    watch: {
        number: function(){
            return this.selectedPhoneNumber = this.number[0]
        },
        tempEmail: function(){
            let emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g
            if(this.tempEmail.slice(-1) == " "){
                if(emailRegex.test(this.tempEmail.trim()) == true){
                    this.email.push(this.tempEmail.trim())
                    this.email = _.uniq(this.email)
                    this.tempEmail = ""
                    this.showErrorEmail = false                    
                } else {
                    this.$message.error("Invalid email")
                }
            }
        }
    }
}
</script>

